<template>
  <search-filter
      :items="PurchaseTypes"
      keyTitleForAlphabeticalSort="title"
      :selectedFilters="[]"
      :selectedView="'list'"
      :excludedKeys="[]"
      :tableColumns="tableColumns"
      :isActionColumnEnabled="false"
      :readOnly="true"
      @columnClick="false"
  >
    <!--      result infos-->
    <template #resultInfos="{items}">
      ({{ items.length }})
      <span>{{ currency(getPreTaxAmounts(items)) }} HT</span>
    </template>

    <!--      List view-->

    <!--      Average-->
    <template #listView_cell_average="{item}">
      <span>{{ currency(getAverage(item.averages)) }}</span>
      <!--      <span v-if="!isNaN(item.average)">{{ currency(item.average) }}</span>-->
      <!--      <span v-else>{{ currency(0) }}</span>-->
    </template>

  </search-filter>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'
import { capitalize, currency } from '@/utils/filter'

import SearchFilter from '../searchFilter/SearchFilter'
import i18n from '@/libs/i18n'

export default {
  components: {
    SearchFilter
  },
  props: {
    PurchaseTypes: {
      type: Array,
      default: () => []
    },
  },
  setup (props) {
    // console.log(props.PurchaseTypes)
    // ------------------------------------------------
    // Data
    // ------------------------------------------------
    const tableColumns = ref([
      { key: 'type', label: i18n.t('type'), sortable: true },
      { key: 'preTaxAmount', label: i18n.t('preTaxAmount'), sortable: true },
      { key: 'average', label: i18n.t('average'), sortable: true },
    ])

    // ------------------------------------------------
    // Computed
    // ------------------------------------------------

    // ------------------------------------------------
    // Watch
    // ------------------------------------------------

    // ------------------------------------------------
    // Methods
    // ------------------------------------------------
    const getPreTaxAmounts = (concernedItems) => {
      let preTaxAmounts = 0
      concernedItems.forEach(i => preTaxAmounts += parseFloat(i.preTaxAmount))
      return preTaxAmounts
    }

    const getAverage = (averages) => {
      // console.log(averages)
      if (averages.length == 0) {
        return 0;
      } else {
        let average = 0

        averages.forEach(x => average += parseFloat(x))

        return average/averages.length
      }
    }

    // ------------------------------------------------
    // Mounted
    // ------------------------------------------------

    // ------------------------------------------------
    // Setup
    // ------------------------------------------------
    return {
      // Components
      capitalize,
      currency,

      // Data
      tableColumns,

      // Computed
      // items,

      // Methods
      getPreTaxAmounts,
      getAverage,
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {},
  mounted () {
  },
  created () {
  }
}
</script>

<style lang="scss">

</style>